const RegistrationStatus = Object.freeze({
  OPEN: 'open',
  INVITATION_LIST: 'invitation_list',
  MEMBERSHIP: 'membership',
  CLOSED: '',
})

export default RegistrationStatus
